import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import { Box, Stack } from '@mui/system';
import TournamentDto, { mapFdcpSeasonToTournamentDto } from 'common/dto-types/tournament-dto';
import AsyncSelectSearchFormField from 'components/async-select-search-form-field';
import FDCPServices from 'fdcp/fdcp-services';
import { Form, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import SyncFdcpFormProps, { SyncFdcpFields } from './dto';

export const SyncFdcpForm = (props: SyncFdcpFormProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const initialFormValue = {
        tournament: null,
    };

    const validationSchema = Yup.object({
        tournament: Yup.object<TournamentDto>().required(),
    });

    const mappingOptionToLabel = (option: TournamentDto): string => {
        if (option.name && option.fdcpId) return `${option.name} - [${option.fdcpId}]`;
        return '';
    };

    const onSubmit = async (value: SyncFdcpFields) => {
        if (!props.onSubmit || !value.tournament || !value.tournament.fdcpId) return;

        setIsLoading(true);
        await props.onSubmit(value.tournament.fdcpId);
        setIsLoading(false);
    };

    const formik = useFormik<SyncFdcpFields>({
        initialValues: initialFormValue,
        validationSchema,
        onSubmit,
    });

    const { values, isValid, handleSubmit } = formik;

    return (
        <FormikProvider value={formik}>
            <Form onSubmit={handleSubmit}>
                <Box sx={{ p: 2.5 }}>
                    <Stack spacing={1}>
                        <AsyncSelectSearchFormField
                            label={props.label}
                            name="tournament"
                            fetchData={(inputValue) =>
                                FDCPServices.searchSeasonByName({ searchString: inputValue }).then((seasons) =>
                                    seasons.map((season) => mapFdcpSeasonToTournamentDto(season)),
                                )
                            }
                            getOptionLabel={mappingOptionToLabel}
                            isOptionEqualToValue={(option, selectedValue) => {
                                return (option as TournamentDto).fdcpId === (selectedValue as TournamentDto).fdcpId;
                            }}
                            filterOptions={(x) => x}
                            multiple={false}
                        />
                    </Stack>
                    <Stack sx={{ pt: 2 }} spacing={1} direction="row" justifyContent="flex-end">
                        <Button size="small" color="error" disabled={isLoading} onClick={props.closeFdcpForm}>
                            Cancel
                        </Button>
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            size="small"
                            loading={isLoading}
                            disabled={!isValid || values.tournament == null}
                        >
                            Submit
                        </LoadingButton>
                    </Stack>
                </Box>
            </Form>
        </FormikProvider>
    );
};
